var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfigure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "15px",
    viewBox: "0 0 19 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stepper-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MacBook-Air-13\"-Copy-16",
    transform: "translate(-1076.000000, -190.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1083.51007,191.875 C1083.22413,190.773296 1082.21909,190.002061 1081.06667,190 C1079.91424,190.002061 1078.90921,190.773296 1078.62327,191.875 L1076,191.875 L1076,193.125 L1078.62327,193.125 C1078.90921,194.226704 1079.91424,194.997939 1081.06667,195 C1082.21909,194.997939 1083.22413,194.226704 1083.51007,193.125 L1095,193.125 L1095,191.875 L1083.51007,191.875 Z M1081.5,193 C1081.22386,193 1081,192.776142 1081,192.5 C1081,192.223858 1081.22386,192 1081.5,192 C1081.77614,192 1082,192.223858 1082,192.5 C1082,192.776142 1081.77614,193 1081.5,193 Z M1089.93333,195 C1088.78091,195.002061 1087.77587,195.773296 1087.48993,196.875 L1076,196.875 L1076,198.125 L1087.48993,198.125 C1087.77587,199.226704 1088.78091,199.997939 1089.93333,200 C1091.08576,199.997939 1092.09079,199.226704 1092.37673,198.125 L1095,198.125 L1095,196.875 L1092.37673,196.875 C1092.09079,195.773296 1091.08576,195.002061 1089.93333,195 Z M1090.5,198 C1090.22386,198 1090,197.776142 1090,197.5 C1090,197.223858 1090.22386,197 1090.5,197 C1090.77614,197 1091,197.223858 1091,197.5 C1091,197.776142 1090.77614,198 1090.5,198 Z M1081.06667,200 C1079.91424,200.002061 1078.90921,200.773296 1078.62327,201.875 L1076,201.875 L1076,203.125 L1078.62327,203.125 C1078.90921,204.226704 1079.91424,204.997939 1081.06667,205 C1082.21909,204.997939 1083.22413,204.226704 1083.51007,203.125 L1095,203.125 L1095,201.875 L1083.51007,201.875 C1083.22413,200.773296 1082.21909,200.002061 1081.06667,200 L1081.06667,200 Z M1081.5,203 C1081.22386,203 1081,202.776142 1081,202.5 C1081,202.223858 1081.22386,202 1081.5,202 C1081.77614,202 1082,202.223858 1082,202.5 C1082,202.776142 1081.77614,203 1081.5,203 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigure);
export default __webpack_public_path__ + "static/media/configure.094a78c9211f4d6f835dd8e594474828.svg";
export { ForwardRef as ReactComponent };